<!-- 面试详情 -->
<template>
  <div class="view-details">
    <!-- 导航栏 -->
    <van-nav-bar title="面试详情" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 标题 -->
    <div class="details-title">
      <img :src="details&&details.company_info.logo" class="logos" />
      <span class="details-name">{{details&&details.company_info.name}}</span>
    </div>
    <!-- 内容 -->
    <div class="details-content">
      <div class="details-men">
        <div class="men-left">
          <!-- <img src="@/assets/img/enimg/user.png" /> -->
          {{details&&details.company_info.contact}}
        </div>
        <img
          src="@/assets/img/home/tel.png"
          class="tel"
          @click="telphone(details&&details.company_info.telphone)"
        />
      </div>
      <div class="details-info">
        <span class="details-left">时间</span>
        <span class="details-right">{{details&&details.apply_info.interview_time}}</span>
      </div>
      <div class="details-info" @click="navDetails">
        <span class="details-left">职位</span>
        <span
          class="details-right"
        >{{details&&details.job_info.name}}·{{details&&details.job_info.salary_type==0?`${details.job_info.min_salary}-${details.job_info.max_salary}`:'面议'}}</span>
        <img src="@/assets/img/position/into.png" class="back" />
      </div>
      <div class="details-info">
        <span class="details-left">地址</span>
        <span class="details-right">{{details&&details.company_info.address}}</span>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="request-btn" @click="canleView">
      <button class="btns">拒绝面试</button>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { interviewDetail, interviewCancel } from "@/api/apiData";
export default {
  components: {},
  data() {
    return {
      id: "",
      details: ""
    };
  },
  computed: {},
  methods: {
    //  返回上一页
    goBack() {
      this.$router.back();
    },
    getDetails() {
      const that = this;
      interviewDetail({ job_apply_id: that.id[0] }).then(res => {
        //(res);
        if (res.code == 1) {
          that.details = res.data;
        } else {
          Toast.fail({
            forbidClick: true,
            message: res.msg
          });
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 拨打电话
    telphone(val) {
      window.location.href = `tel:${val}`;
    },
    // 取消面试
    canleView() {
      Dialog.confirm({
        // title: "标题",
        message: "是否取消面试"
      })
        .then(() => {
          // on confirm
          interviewCancel({ job_apply_id: this.id[0] }).then(res => {
            if (res.code == 1) {
              Toast.success({
                forbidClick: true,
                message: "取消成功"
              });
              setTimeout(res => {
                this.$router.back();
              }, 2000);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 跳转到职位详情
    navDetails() {
      this.$router.push({
        path: "/position/positionDetails",
        query: {
          id: this.id[1]
        }
      });
    }
  },
  created() {
    const that = this;
    that.id = that.$route.query.id;
  },
  mounted() {
    const that = this;
    that.getDetails();
  }
};
</script>
<style lang='less' scoped>
// 去除顶部导航栏的底部线
/deep/[class*="van-hairline"]::after {
  border: none;
}
//标题
.view-details {
  padding: 0 0.4rem;

  .details-title {
    padding: 0.33rem 0;
    display: flex;
    align-items: center;
    border-bottom: 0.01rem solid rgba(178, 178, 178, 0.5);
    .logos {
      width: 0.54rem;
      height: 0.54rem;
      margin-right: 0.15rem;
      align-self: flex-start;
    }
    .details-name {
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.45rem;
      color: rgba(51, 51, 51, 1);
    }
  }
}
// 内容
.details-content {
  .details-men {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.32rem 0;
    .men-left {
      display: flex;
      align-items: center;
      font-size: 0.28rem;
      font-weight: bold;
      line-height: 0.24rem;
      color: rgba(51, 51, 51, 1);
      img {
        width: 0.54rem;
        height: 0.54rem;
        border-radius: 50%;
        margin-right: 0.1rem;
      }
    }
    .tel {
      width: 0.54rem;
      height: 0.54rem;
      border-radius: 50%;
    }
  }
  .details-info {
    display: flex;
    align-items: center;
    padding: 0.2rem 0;
    .details-left {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(128, 128, 128, 1);
      flex: 1;
      align-self: flex-start;
      padding-top: 0rem;
    }
    .details-right {
      font-size: 0.28rem;
      font-weight: bold;
      line-height: 0.4rem;
      color: rgba(51, 51, 51, 1);
      flex: 9;
    }
  }
}
</style>